/// <reference path="../../typings/tsd.d.ts" /> 

module warsApp.services {
    import EntityQuery = breeze.EntityQuery;

    export class ProcessSubTypeService extends services.DataService<Wars.Domain.Model.ProcessSubTypeConfiguration> {

        constructor(
            injectedBreeze: typeof breeze,
            $q: angular.IQService, private $http: angular.IHttpService,
            private securityMatrixService: services.SecurityMatrixService)
        {
            super(injectedBreeze, $q);
        }

        public createConfig(processConfig: Wars.Domain.Model.ProcessConfiguration): void {
            var newProcessSubTypeConfiguration = this.createNewEntity<Wars.Domain.Model.ProcessSubTypeConfiguration>("ProcessSubTypeConfiguration");
            newProcessSubTypeConfiguration.header = "Select Process Sub Type";
            newProcessSubTypeConfiguration.dropdownLabel = "Process Sub Type";
            newProcessSubTypeConfiguration.buttonLabel = "Create Process";

            this.createNewSubType(newProcessSubTypeConfiguration);

            processConfig.mySubTypeConfiguration = newProcessSubTypeConfiguration;
            processConfig.subTypeConfiguration_id = newProcessSubTypeConfiguration.id;
        }

        public createNewSubType(processSubTypeConfiguration: Wars.Domain.Model.ProcessSubTypeConfiguration): Wars.Domain.Model.ProcessSubType {
            var newProcessSubType = this.createNewEntity<Wars.Domain.Model.ProcessSubType>("ProcessSubType");
            newProcessSubType.name = "New Sub Type";
            newProcessSubType.displayName = "";
            newProcessSubType.isActive = true;
            newProcessSubType.uniqueIdentifier = services.UtilityService.generateGuidComb();

            newProcessSubType.myProcessSubTypeConfiguration = processSubTypeConfiguration;
            newProcessSubType.processSubTypeConfiguration_id = processSubTypeConfiguration.id;

            var securityMatrix = this.securityMatrixService.createSecurityRow(false);
            var matrix = {"00000000-0000-0000-0000-000000000000": {
                alwaysVisible: true
            }};

            securityMatrix.matrixJson = JSON.stringify(matrix);

            newProcessSubType.myCreateSecurityMatrix = securityMatrix;
            newProcessSubType.securityMatrix_id = securityMatrix.id;

            processSubTypeConfiguration.myProcessSubTypes.push(newProcessSubType);

            return newProcessSubType;
        }


        public getExecutionProcessSubTypes(): ng.IPromise<Wars.Domain.Model.Dtos.ProcessSubTypeDto[]> {
            var d = this.$q.defer();

            this.$http.get('./api/ProcessType/SubTypes').then(r => {
                d.resolve(r.data);
            });

            return d.promise;
        }

    }
}


warsApp.registerService('ProcessSubTypeService', ['breeze', '$q', '$http','securityMatrixService']);